/**
 * Paths and link parameters that more than one module has to agree on.
 *
 * Each of these used to be spelled out where it was needed - the gate, the
 * concierge landing page, the safe-redirect fallback - so that a rename or a
 * typo in one place silently broke the journey in another. They live here, in
 * a module with no imports, so any of those can use them without a cycle.
 */

/** Where an absent or unsafe "go here afterwards" target falls back to. */
export const HOME_PATH = "/";

/** The sign-in screen; the auth gate sends an unauthenticated visitor here. */
export const LOGIN_PATH = "/login";

/** The sign-out screen. */
export const LOGOUT_PATH = "/logout";

/**
 * Where a concierge link (`/enter?token=...`) is redeemed. Also the one route
 * the app shell leaves un-initialised for analytics until the actor is known.
 */
export const ENTER_PATH = "/enter";

/** The forgotten-password screen and the reset link's landing page. */
export const RESET_PASSWORD_PATH = "/reset-password";

/** The page a supplier-match email's confirm link lands on. */
export const SUPPLIER_MATCH_CONFIRM_PATH = "/supplier-match-confirm";

/** The first-login delivery-address step (KAN-293). */
export const ONBOARDING_PATH = "/onboarding";

/**
 * The set-password step (KAN-293). An approval email's link leads here, and so
 * does the auth gate for any salon session that has no password yet (KAN-306).
 */
export const ACTIVATE_PATH = "/activate";

/**
 * The `source` search param the auth gate puts on `/activate` when it sends a
 * passwordless salon there. It picks the page's copy and the `password_set`
 * analytics source. The gate does not know how the session arrived (a cart link,
 * or a waitlist salon who left `/activate` unsaved), so the value is neutral; the
 * approval email's link carries no `source`, so a bare `/activate` is the
 * activation variant.
 */
export const SET_PASSWORD_GATE_SOURCE = "gate";

/**
 * The `next` value on the approval email's concierge link
 * (`/enter?token=...&next=activate`). It names the step, not the path: it is a
 * link parameter, so it carries no leading slash.
 */
export const ACTIVATE_NEXT = "activate";
